module.exports = __webpack_public_path__ + "img/c-robot.57e67a77.svg";